var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGesture = function SvgGesture(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 110 120"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#7B4EF8",
    strokeWidth: 3,
    d: "M59.898 108.5h-12.22c-6.5 0-12.095-4.588-13.37-10.96a13.6 13.6 0 0 0-.958-2.969l-3.648-8.025a66.5 66.5 0 0 1-5.188-37.638l.56-3.641a47.8 47.8 0 0 1 6.25-17.307l8.623-14.371a7.3 7.3 0 0 1 4.482-3.321l.296-.074a6.984 6.984 0 0 1 7.28 10.965l-.232.31a29.44 29.44 0 0 0-5.828 15.802l-.416 6.583c-.02.301.332.477.561.282l8.519-7.262a18.67 18.67 0 0 1 15.77-4.098l.388.077a16.7 16.7 0 0 1 5.976 2.476l2.718 1.812a7.14 7.14 0 0 1 2.814 3.684l.037.111a6.988 6.988 0 0 1-9.225 8.699l-1.773-.71a10.62 10.62 0 0 0-12.235 3.226l-1.869 2.336A14.65 14.65 0 0 0 54 63.64v5.151a8.8 8.8 0 0 0 3.919 7.322l.416.278a7.777 7.777 0 0 0 11.792-4.334l2.709-9.482a9.63 9.63 0 0 1 4.954-5.97l2.548-1.273a5.68 5.68 0 0 1 8.13 6.097l-2.772 15.246a23.37 23.37 0 0 1-9.41 14.836l-7.021 5.015a6.6 6.6 0 0 0-2.765 5.373 6.6 6.6 0 0 1-6.602 6.602Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#7B4EF8",
    strokeWidth: 3,
    d: "m49.672 24.376 7.614-6.23a4.735 4.735 0 0 1 7.338 1.77l.527 1.206a8.77 8.77 0 0 1-3.165 10.803l-3.943 2.636"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#7B4EF8",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M48.604 42.016v0c-5.214 4.073-8.468 10.208-8.885 16.812v0"
  })));
};
export default SvgGesture;